module.exports = __webpack_public_path__ + "img/3.39c1ad69.svg";